export default function selectTrelloLabelsById(state) {
  return state.integrations.thirdPartyData.trello.labels
}
